<template>
  <div class="flex-align-center" :style="generateStyle(_items)">
    <op-bar-item v-for="(item, index) in _items" :key="index"
                 :data="data" :item="item" :style="generateStyle(item)"
                 :requestBody="requestBody"
                 @search="arg => $emit('search', arg)" />
  </div>
</template>

<script>
import OpBarItem from './op-bar-item'

export default {
  components: {OpBarItem},
  name: 'op-bar-items',
  props: {
    data: {},
    requestBody: {},
    items: {}
  },
  computed: {
    _items () {
      return this.items &&
        (this.items instanceof Array ? this.items : [this.items])
    }
  },
  methods: {
    generateStyle (_item) {
      const items = _item instanceof Array ? _item : [_item]

      const findFlex = () => {
        for (let item of items) {
          if (item && item.flex) {
            return item.flex
          }
        }
      }

      return {
        flex: findFlex() || 'none'
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/di-ding/common/op-bar-items.vue